// removed by extract-text-webpack-plugin
module.exports = {"component":"mrl4VD0M729CraCIwgeyu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Mobile/OneClickBuy/oneClickBuy.css
// module id = 1246
// module chunks = 2